import uniqWith from 'lodash/uniqWith'
import isEqual from 'lodash/isEqual'

export default function(products) {
  const copied = products.map(frame => ({
    ...frame,
    width: frame.height,
    height: frame.width,
    isSystem: true,
  }))

  return uniqWith([...products, ...copied], (a, b) => {
    return isEqual({ width: a.width, height: a.height }, { width: b.width, height: b.height })
  })
}



// WEBPACK FOOTER //
// ./src/utils/fillDimensions.js